// /////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                     ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
// /////////////////////////////////////////////////////////////////////

import { UsageDataItem } from '../UsageDataItem';
import {
    CustomerUsageDataBase,
    JobUsageDataBase,
    OverallUsageDataBase,
    UserUsageDataBase
} from '../../clients/Client';
import { UsageSummaryUI } from '../UsageSummaryUI';

export class UsageDataTranslator {
    static TranslateUsageSummary(summaryData: OverallUsageDataBase): UsageSummaryUI {
        const summaryUI = new UsageSummaryUI(summaryData.jobRunCount!, summaryData.runTimeSeconds!);
        summaryUI.CustomerData = [];
        summaryData.customerUsageDatas!.forEach(c => {
            const customerData = this.TranslateItem(c);
            summaryUI.CustomerData.push(customerData);
        });

        return summaryUI;
    }

    static TranslateItem(item: any): UsageDataItem {
        console.log(item);
        if (item instanceof CustomerUsageDataBase || item instanceof CustomerUsageDataBase) {
            return this.TranslateCustomer(item);
        } else if (item instanceof UserUsageDataBase || item instanceof UserUsageDataBase) {
            return this.TranslateUser(item);
        } else if (item instanceof JobUsageDataBase || item instanceof JobUsageDataBase) {
            return this.TranslateJob(item);
        } else {
            throw Error('Unsupported object type sent for translation');
        }
    }

    private static TranslateCustomer(customer: CustomerUsageDataBase): UsageDataItem {
        const customerItem = new UsageDataItem(
            customer.customerId!,
            customer.customerName!,
            customer.level!.toString(),
            customer.jobRunCount!,
            customer.runTimeSeconds!
        );
        customerItem.Children = [];

        customer.userUsageDatas!.forEach(u => {
            const user = this.TranslateItem(u);
            customerItem.Children.push(user);
        });

        return customerItem;
    }

    private static TranslateUser(user: UserUsageDataBase): UsageDataItem {
        const userItem = new UsageDataItem(
            user.userId!,
            user.username!,
            user.level!.toString(),
            user.jobRunCount!,
            user.runTimeSeconds!
        );

        user.jobUsageDatas!.forEach(j => {
            const jobItem = this.TranslateItem(j);
            userItem.Children.push(jobItem);
        });

        return userItem;
    }

    private static TranslateJob(job: JobUsageDataBase): UsageDataItem {
        const jobItem = new UsageDataItem(
            job.jobId!,
            job.jobName!,
            job.level!.toString(),
            job.jobRunCount!,
            job.runTimeSeconds!
        );

        return jobItem;
    }
}
